import { render, staticRenderFns } from "./principalMailBoxDialog.vue?vue&type=template&id=4a5d3a13&"
import script from "./principalMailBoxDialog.vue?vue&type=script&lang=js&"
export * from "./principalMailBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./principalMailBoxDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports